import React, { Component } from 'react';
import MyJobItem from './MyJobItem';
import { Loader } from "../../../../common/elements";
import JobsMpu from '../../../../common/adverts/googleDFP/JobsMpu';

class MyJobList extends Component {
  render() {
    const { jobs, removeJobFromFavourites, addJobToFavourites } = this.props;

    if (!jobs) {
      return <Loader />;
    }
    return (
      <div className="jobs-list">
        <div className="row top-of-list job__card-list">
          {
            Object.keys(jobs).map((job, index) =>
              jobs[job].id
                ? <MyJobItem key={index}
                  addJobToFavourites={addJobToFavourites}
                  removeJobFromFavourites={removeJobFromFavourites}
                  index={index}
                  job={jobs[job]}
                />
                : <JobsMpu key={index} {...jobs[job]} />
            )
          }
        </div>
      </div>
    );
  };
}

export default MyJobList;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/MyJobList.js